import React from 'react';

const Loader = () => (
  <img src="/assets/loader_tiny.gif" alt="Loading..." />
);

export default Loader;
